<template>
  <div class="content">
    <div class="row filter-section">
      <div class="col-md-4">
        <ArtistSelect :show-members="false" :is-filter="true" v-model="selectedUnitId" :initial-unit-id="selectedUnitId" @unitChangeEvent="onUnitChange" />
      </div>
      <div class="col-md-4">
        <h4 class="card-title text-left">채널</h4>
        <div class="row">
          <el-select class="col-md-12 select-primary" size="large" placeholder="채널" v-model="selectedNamespace" @change="onNamespaceChange">
            <el-option v-for="option in namespaceOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-4">
        <h4 class="card-title text-left">상태</h4>
        <div class="row">
          <el-select class="col-md-12 select-primary" size="large" placeholder="상태" v-model="selectedStateGroup" @change="onStateChange">
            <el-option v-for="option in stateGroupOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="row">
      <ReportsTableView
        class="table-view col-md-12"
        title=""
        ref="tableView"
        :namespace="selectedNamespace"
        :unitId="selectedUnitId"
        :status="searchStatus"
        :show-actions="selectedStateGroup === 1 && selectedNamespace !== 3000"
        :onApprove="onClickApprove"
        :onReject="onClickReject"
        :current-page="currentPage"
        @pageChanged="onPageChange"
      />
    </div>

    <ReportNotificationModal
      :mode="confirmModal.mode"
      :namespace="selectedNamespace"
      :shouldShow="confirmModal.show"
      :messages="confirmModal.messages"
      :onConfirm="onConfirmModal"
      :onCancel="onCancelModal"
    />
  </div>
</template>

<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import ReportsTableView from "./ReportsTableView.vue";
import { ReportChannel, ReportChannelOptions } from "@/common/ReportChannels";
import { ReportState } from "./ReportState";
import ReportNotificationModal from "./ReportNotificationModal.vue";
import { Toast } from "@/util/Toast";
import { UserData } from "@/util/UserData";
import * as _ from "lodash";
import { URLUtils } from "@/util/URLUtils";

const StateGroup = Object.freeze({
  IN_QUEUE: 1,
  COMPLETED: 2,
});

const CONFIRM_MODE_APPROVAL = "approval";
const CONFIRM_MODE_REJECTION = "rejection";
const DEFAULT_UNIT_ID = 1;
const DEFAULT_NAMESPACE = ReportChannel.RADAR;
const DEFAULT_STATE = StateGroup.IN_QUEUE;

export default {
  name: "ReportContents",
  components: {
    ArtistSelect,
    ReportsTableView,
    ReportNotificationModal,
  },
  async created() {
    const fallbackUnitId = UserData.get(UserData.LAST_UNIT_ID, DEFAULT_UNIT_ID);

    if (_.isEmpty(this.$route.query)) {
      await this.$router.push(`/reports?unitId=${fallbackUnitId}&namespace=${DEFAULT_NAMESPACE}&state=${StateGroup.IN_QUEUE}&page=1`);
      return;
    }

    const { unitId, namespace, state, page } = this.$route.query;

    this.selectedUnitId = unitId ? parseInt(unitId, 10) : fallbackUnitId;
    this.selectedNamespace = namespace ? parseInt(namespace, 10) : DEFAULT_NAMESPACE;
    this.selectedStateGroup = state ? parseInt(state, 10) : DEFAULT_STATE;
    this.currentPage = page ? parseInt(page, 10) : 1;
  },
  computed: {
    searchStatus: function () {
      if (this.selectedStateGroup === StateGroup.IN_QUEUE) {
        return this.todoStatus;
      } else {
        return this.completedStatus;
      }
    },
  },
  data() {
    return {
      selectedUnitId: DEFAULT_UNIT_ID,
      selectedNamespace: DEFAULT_NAMESPACE,
      selectedStateGroup: StateGroup.IN_QUEUE,
      currentPage: 1,
      namespaceOptions: ReportChannelOptions,
      todoStatus: [ReportState.SUBMITTED, ReportState.IN_PROCESSING],
      completedStatus: [ReportState.APPROVED, ReportState.REJECTED],
      stateGroupOptions: [
        { label: "처리 대기", value: StateGroup.IN_QUEUE },
        { label: "처리 완료", value: StateGroup.COMPLETED },
      ],
      confirmModal: {
        show: false,
        mode: CONFIRM_MODE_APPROVAL,
        messages: [],
        report: null,
      },
    };
  },
  methods: {
    async onUnitChange(change) {
      const queries = {
        ...this.$route.query,
        unitId: change.unitId,
      };

      try {
        await this.$router.push(`/reports?${URLUtils.objectToQueryString(queries)}`);
      } catch (ex) {}
    },
    async onNamespaceChange(namespace) {
      const queries = {
        ...this.$route.query,
        namespace,
      };

      try {
        await this.$router.push(`/reports?${URLUtils.objectToQueryString(queries)}`);
      } catch (ex) {}
    },

    async onStateChange(state) {
      const queries = {
        ...this.$route.query,
        state,
      };

      try {
        await this.$router.push(`/reports?${URLUtils.objectToQueryString(queries)}`);
      } catch (ex) {}
    },
    async onPageChange(page) {
      await this.$refs.tableView.refreshReports(page);
    },
    onClickApprove(report) {
      this.showConfirmModal(report, CONFIRM_MODE_APPROVAL, ["승인 알림 전송"]);
    },
    onClickReject(report) {
      this.showConfirmModal(report, CONFIRM_MODE_REJECTION, ["반려 알림 전송"]);
    },
    showConfirmModal(report, mode, messages) {
      this.confirmModal.report = report;
      this.confirmModal.mode = mode;
      this.confirmModal.messages = messages;

      this.confirmModal.show = true;
    },
    async onConfirmModal(sendPushToReporter, sendPushToWriter) {
      this.confirmModal.show = false;

      let isSucceeded = true;
      const reportUserId = this.confirmModal.report.reporterUserId;
      const writeUserId = this.confirmModal.report.authorUserId;
      if (this.confirmModal.mode === CONFIRM_MODE_APPROVAL) {
        try {
          await this.$axios.post(`/reports/namespaces/${this.selectedNamespace}/${this.confirmModal.report.id}/approval`, {
            reportUserId: sendPushToReporter ? reportUserId : null,
            writeUserId: sendPushToWriter ? writeUserId : null,
          });
          Toast.success("승인 처리에 성공하였습니다.");
        } catch (err) {
          isSucceeded = false;
          Toast.error("승인 처리에 실패 했습니다.");
        }
      } else {
        try {
          await this.$axios.post(`/reports/namespaces/${this.selectedNamespace}/${this.confirmModal.report.id}/rejection`, {
            reportUserId: sendPushToReporter ? reportUserId : null,
          });
          Toast.success("반려 처리에 성공하였습니다.");
        } catch (err) {
          isSucceeded = false;
          Toast.error("반려 처리에 실패 했습니다.");
        }
      }

      if (isSucceeded) {
        await this.$refs.tableView.refreshReports();
      }
    },
    async onCancelModal() {
      this.confirmModal.show = false;
    },
  },
};
</script>
<style lang="scss">
.table-view {
  margin-left: 0;
  margin-bottom: 60px;
}
.filter-section {
  margin-bottom: 50px;
}
</style>
